import { Card } from "antd";
import { LucideUserX, LucideClock, LucideCalendar, LucideTrendingUp } from "lucide-react";

const absenceData = [
  {
    id: 1,
    label: "Currently Out",
    count: 2,
    category: "currently-out",
    icon: <LucideUserX />,
  },
  {
    id: 2,
    label: "Upcoming (This Week)",
    count: 1,
    category: "this-week",
    icon: <LucideClock />,
  },
  {
    id: 3,
    label: "Upcoming (This Month)",
    count: 3,
    category: "this-month",
    icon: <LucideCalendar />,
  },
  {
    id: 4,
    label: "Total Days (Month)",
    count: 18,
    category: "total",
    icon: <LucideTrendingUp />,
  },
];

export default function AbsenceSummaryCard() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {absenceData.map((item) => (
        <Card
          key={item.id}
          className={`card-border-s ${item.category} rounded-2xl`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[12px] text-muted-foreground mb-1">{item.label}</p>
              <p className="text-[24px] font-semibold card-text">{item.count}</p>
            </div>
            <div className="avatar rounded-lg">
              {item.icon}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
